module.exports = require("@swa-ui/placements/src/MessageBlock/MessageBlock.module.scss");